import React from 'react';
import NoResullImage from '../../../../src/assets/images/web-isn/no-result-found.png';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
const NoResultFound = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const getLanguage = localStorage.getItem('language');
  const gotoHome = () => {
    history.push(`/${getLanguage}`);
  };
  return (
    <div className="text-center extra-btn mb-5 mt-5">
      <img className="no-result" src={NoResullImage} alt="no-result"></img>
      <h4 className="mt-1 mb-2">
        <strong>{t('notResultPgae.noResultFound')}</strong>
      </h4>
      <p>{t('notResultPgae.textMessage')}</p>
      <button className="block-button booknow-block-btn btn-back-home" onClick={gotoHome}>
        {t('notResultPgae.goHome')}
      </button>
    </div>
  );
};
export default NoResultFound;
